import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import classes from './VariationCard.module.scss';
import { VariationCardProps } from "../../interfaces/props/VariationCardProps";
import ImageWrapper from "../../components/image-wrapper/ImageWrapper";
import { useMemo } from "react";
import NameHelper from '../../helpers/name.helper';
import { Relations } from '../../enums/Relations';

const fallbackImage = <Box
  component={'img'}
  className='image-variations-placeholder'
/>;

const VariationCard = ({ variation, image }: VariationCardProps) => {
  const renderImage = useMemo(() => {
    if (image.length > 0) {
      return <ImageWrapper
        className='image-all-articles'
        alt='article'
        src={image}
        fallbackElement={fallbackImage}
      />
    }

    return fallbackImage;
  }, [image]);
  
  const renderAttribute = (label: string, attribute: string) => {
    return (
      attribute && (
        <Typography className={`${classes['original-on-text']} py-3 px-3 fs-7 d-flex`} >
          {`${label}${attribute}`}
        </Typography>
      )
    );
  };

  return (
    <Box className={`${classes.card} d-flex mb-3 border`}>
      <Box>
        <Link
          to={`../variation/${variation.id}`}
          style={{ textDecoration: 'none', color: 'black' }}
        >
          {renderImage}
        </Link>
      </Box>
      <Box className='d-flex flex-column justify-content-between w-100'>
        <Box>
          <Link
            to={`../variation/${variation.id}`}
            style={{ textDecoration: 'none', color: 'black' }}
          >
            <Box className='d-flex justify-content-between pt-3'>
              <Typography
                className='px-3 text-headline'
              >
                {variation.attributes.headlines}
              </Typography>
              <Typography
                align='right'
                className={`${classes['date-color']} pt-2 px-3 fs-7`}
              >
                {dayjs(variation.attributes.createdAt).format('DD.MM.YYYY')}
              </Typography>
            </Box>
            <Box className='d-flex flex-column flex-sm-row'>
              {renderAttribute('Type: ', variation.attributes.type)}
              {renderAttribute('Title: ', variation.attributes.headlinesType)}
              {renderAttribute('Length: ', variation.attributes.length)}
              {null !== variation.attributes.structure && (
                <Typography className={`${classes['original-on-text']} py-3 px-3 fs-7 d-flex`} >
                  Structure: {variation.attributes.structure}
                </Typography>
              )}
            </Box>
          </Link>
        </Box>
        <Box className='d-flex flex-column flex-sm-row justify-content-between'>
          {renderAttribute('Published for ', NameHelper.getNameFromEntity(variation, Relations.SITE))}
          {renderAttribute('Language ', NameHelper.getNameFromEntity(variation, Relations.LANGUAGE))}
        </Box>
      </Box>
    </Box>
  );
};

export default VariationCard;
